/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDeploymentCommerceHistory } from './vcdsDeploymentCommerceHistory';
import { EditionEnum } from './editionEnum';
import { ReportedCommerce } from './reportedCommerce';
import { CommerceModeEnum } from './commerceModeEnum';


export interface DetailedVcdsDeploymentCommerce { 
    edition?: EditionEnum;
    /**
     * Expiry date
     */
    expiry_date?: Date;
    mode?: CommerceModeEnum;
    reported_commerce?: ReportedCommerce;
    history?: Array<VcdsDeploymentCommerceHistory>;
}
export namespace DetailedVcdsDeploymentCommerce {
}


